import { helpers } from "@vuelidate/validators";

export const Rules = {
  alphaNumAndDotValidator: {
    validator: helpers.regex(/^[a-z\d. ()',&#-]*$/i),
    message: "We don't allow special characters other than # & ( ) - ' , .",
  },
  emailspecialCharValidation: {
    validator: helpers.regex(/^[a-zA-Z0-9!@#$%^&*{|}'=;:?/+,._-\s]*$/i),
    message:
      "We don't allow special characters other than ! @ # $ % ^ & * - _ = + { } | ' ? /",
  },
  emailRegix: {
    validator: helpers.regex(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ),
    message: "Enter a valid email address",
  }
};
